import { useProjectNotes } from "../../lib/queries";
import { renderMarkdown } from "../../lib/markdown";
import { relativeTime } from "../../lib/format";

export default function NoteDetailDrawer({ id }: { id: string }) {
  const { data: notes = [] } = useProjectNotes();
  const n = notes.find((x) => x.id === id);
  if (!n) return <div className="px-4 py-3 text-xs text-text-quiet">note not found</div>;

  const interpreted = !!n.interpreted_by_agent_at;
  const actions = n.agent_actions ?? [];

  return (
    <div className="flex flex-col gap-3 p-4">
      <div>
        <span
          className="font-data text-micro"
          style={{ letterSpacing: "0.13em", color: "var(--text-quiet)" }}
        >
          NOTE · {n.project}
        </span>
        <div className="mt-1 flex items-center gap-2">
          <span
            className="font-data text-micro inline-flex items-center gap-1 rounded-sm border px-1.5 py-0.5"
            style={{
              borderColor: interpreted ? "var(--green)" : "var(--amber)",
              color: interpreted ? "var(--green)" : "var(--amber)",
            }}
          >
            {interpreted ? "✓ interpreted" : "⋯ pending"}
          </span>
          <span className="font-data text-micro text-text-quiet">
            {relativeTime(n.created_at)}
          </span>
          {n.author ? (
            <span className="font-data text-micro text-text-quiet">{n.author}</span>
          ) : null}
        </div>
      </div>
      <div
        className="md-out rounded border border-border bg-surface p-3"
        dangerouslySetInnerHTML={{ __html: renderMarkdown(n.body) }}
      />
      {actions.length > 0 ? (
        <div className="rounded border border-border bg-surface p-2">
          <span
            className="font-data text-micro"
            style={{ letterSpacing: "0.1em", color: "var(--text-quiet)" }}
          >
            AGENT ACTIONS
          </span>
          <div className="mt-1 flex flex-col gap-1">
            {actions.map((a, i) => (
              <span
                key={i}
                className="font-data text-xs"
                style={{ color: "var(--accent-strong)" }}
              >
                {a.kind}
                {a.title ? `: ${a.title}` : ""}
              </span>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
}
